module.exports = __webpack_public_path__ + "img/kommune-1718.7b455c41.svg";